








































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./phrase_add.vue";
import Edit from "./phrase_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "workorders/phraselist";

  deleteConfirmContent = "你确定要删除该常用语吗？";

  dispatchTypeDelete = "workorders/deletephrase";

  apps: any[] = [];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "内容", scopedSlots: { customRender: "content" } },
    { title: "app", dataIndex: "app_id" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
    this.loadApps();
  }

  async loadApps() {
    const res = await this.$store.dispatch("api/getApplist", {});
    if (res && res.Data && res.Data !== "{}") {
      this.apps = res.Data;
    }
  }
}
